export const FETCH_BANKS_REQUEST = "FETCH_BANKS_REQUEST";
export const FETCH_BANKS_SUCCESS = "FETCH_BANKS_SUCCESS";
export const FETCH_BANKS_FAILURE = "FETCH_BANKS_FAILURE";

export const SAVE_BANK_REQUEST = "SAVE_BANK_REQUEST";
export const SAVE_BANK_SUCCESS = "SAVE_BANK_SUCCESS";
export const SAVE_BANK_FAILURE = "SAVE_BANK_FAILURE";

export const CHANGE_BANK_STATUS_REQUEST = "CHANGE_BANK_STATUS_REQUEST";
export const CHANGE_BANK_STATUS_SUCCESS = "CHANGE_BANK_STATUS_SUCCESS";
export const CHANGE_BANK_STATUS_FAILURE = "CHANGE_BANK_STATUS_FAILURE";
